import { gql } from '@apollo/client'
import { ClientApollo, Product } from '@nsw-paginas-deslogadas/typings'

export const productsByIdsQuery = gql`
    query productsByIds($productsId: [Int!]!) {
        productsByIds(productsId: $productsId) {
            id
            name
            lowestPriceBrand {
                brandId
                price
            }
        }
    }
`

export const productByIds = (client: ClientApollo, productsId: number[]): Promise<Product[]> => {
    return new Promise((resolve, reject) => {
        client
            .query({ fetchPolicy: 'cache-first', query: productsByIdsQuery, variables: { productsId } })
            .then(result => {
                resolve(result.data.productsByIds)
            })
            .catch(reject)
    })
}
